var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-muted m-0 pt-1 pl-3 text-left text-sm-right"},[_c('small',[_vm._v(" Made by "),_c('a',{attrs:{"href":"https://twitter.com/baumannzone","target":"_blank"}},[_vm._v("Jorge Baumann")]),_vm._v(" for "),_c('a',{attrs:{"href":"https://platzi.com/cursos/avanzado-vue/","target":"_blank"}},[_vm._v("Platzi")])])])
}]

export { render, staticRenderFns }